export const HIDE_MODEL_LIST_REQUEST = 'HIDE_MODEL_LIST_REQUEST';
export const HIDE_MODEL_LIST_SUCCESS = 'HIDE_MODEL_LIST_SUCCESS';
export const HIDE_MODEL_LIST_FAIL = 'HIDE_MODEL_LIST_FAIL';

export const HIDE_MODEL_GET_REQUEST = 'HIDE_MODEL_GET_REQUEST';
export const HIDE_MODEL_GET_SUCCESS = 'HIDE_MODEL_GET_SUCCESS';
export const HIDE_MODEL_GET_FAIL = 'HIDE_MODEL_GET_FAIL';
